import { type ObjectValuesUnionType } from '../utils/typing';

export const Routes = Object.freeze({
  CALENDAR: 'calendar',
  CATEGORY: 'category',
  FAVORITES: 'favorites',
  HISTORY: 'history',
  HOME: 'home',
  LIVE: 'live',
  MATCH: 'match',
  MULTIVIEW: 'multi',
  SPORT: 'sport',
  TOURNAMENT: 'tournament',
  GRID: 'grid',
  SHARE: 'share',
});

export type Route = ObjectValuesUnionType<typeof Routes>;

export const RoutePatterns = Object.freeze({
  BASKET: '/cart',
  BETBUILDER: '/mymatch/:matchId',
  CALENDAR: '/calendar/:hour([0-9]{1,})?',
  CATALOG: '/sports/:sportId/:categoryId?/:tournamentId?',
  SPORTS: '/menu/:sportId?',
  FAVORITES: '/favorites',
  HISTORY: '/history/:status?',
  HISTORY_ITEM_DETAIL: '/history/r/:betslipReference',
  HOME: '/',
  LIVE: '/live/:sportId?/:categoryId?/:tournamentId?',
  MATCH: '/match/:matchId',
  MATCH_AND_BASKETITEM: '/match/:matchId/:betId/:oddId',
  MORE: '/more',
  MULTIVIEW: '/multiplex/:matchId?/:mode?',
  POOL: '/grilles/:poolTitle?',
  GRID_HISTORY: '/grilles/history',
  GRID_HISTORY_DETAIL: '/grilles/history/:gridReference',
  GRID_SHARE: '/grilles/share/:gridReference',
  GRID_PUBLIC: '/grilles/:poolTitle/public/:gridReference?',
  GRIDS: '/grilles',
  KL: '/koh-lanta',
  KL_ENROLLMENT: '/koh-lanta/enrollment',
  KL_ROUND_RULES: '/koh-lanta/round-rules/:obfRoundId',
  KL_ORIENTATION_STEP_DETAIL: '/koh-lanta/orientation-step/:progressIndex-:obfStepId',
  KL_BADGE_DETAILS: '/koh-lanta/badge-details/:obfBadgeId',
  MP: '/monopoly',
  MP_ENROLLMENT: '/monopoly/enrollment',
  MP_FAMILY_DETAIL: '/monopoly/family/:familyId',

  SHARE_BETSLIP: '/share/:betslipReference',

  EXTRAS: '/extras',

  GR: '/gift-race',
  GR_ENROLLMENT: '/gift-race/enrollment',
  GR_ROUND_RULES: '/gift-race/round-rules/:obfRoundId',
  LINE_UP: '/match/:matchId/line-up',

  GRAPHICS_PREFERENCES: '/graphics-preferences',

  BOOM: '/boom',
  BOOM_ENROLLMENT: '/boom/enrollment',
  BOOM_STEP: '/boom/step/:stepId',

  BETSHARE: '#betshare/:betslipReference',
});
